export const ROLES = {
    // viewer: "VIEWER",
    // editor: "EDITOR",
    // owner: "OWNER",
    estudiante:1,
    profesor:2,
    director:3,
    adminti:4,
    familiar:5,
    caja:7,
  };

  const examenes = {
    canCreateExamen: "can-create-examen",
    canEditExamen:"can-edit-examen",
    canDeleteExamen:"can-delete-examen",
    canAddPreguntasExamen:"can-add-preguntas-examen",
    canViewExamen:"can-view-examen"
  }
  let permisos = [examenes];

  export const SCOPES = {
    canCreateInstiElement: "can-create-institution-elements",
    canEditInstiElement: "can-edit-institution-elements",
    canDeleteInstiElement: "can-delete-institution-elements",
    canViewCursos: "can-view-cursos",
    canViewCursosProfesor: "can-view-cursos-Profesor",
    canCreateCursos:"can-create-cursos",
    canDeleteCursos:"can-delete-cursos",
    canViewPagos:"can-view-pagos",
    canViewGrupos:"can-view-grupos",
    canViewsGruposDifusion:"can-view-grupos-difusion",
    canViewCalificaciones:"can-view-calificaciones",
    canDeleteCalificaciones:"can-delete-calificaciones",
    canCreateCalificaciones:"can-create-calificaciones",
    canViewHorario:"can-view-horario-clases",
    canCreateHorario:"can-create-horario",
    canDeleteHorario:"can-delete-horario",
    canUpdateHorario:"can-update-horario",
    canCreateFactura:"can-create-factura",
    canCreatePagoManual:"can-create-pago-panual",
    canCreateArchivos:"can-create-archivos",
    canDeleteArchivosOtros:"can-delete-archivos-otros-usuarios",
    canUploadPerfilAlumnos:"can-upload-perfil-alumnos",
    canViewUserList:"can-view-user-list",
    canCreateUser:"can-create-user",
    canTagsList:"can-tag-list", ...examenes
  }

//   for (const permiso of permisos) {
//     Object.assign(SCOPES, permiso)
//   }

  
  
  export const PERMISSIONS = {
    [ROLES.estudiante]: [
        SCOPES.canViewCursos,
        SCOPES.canViewPagos,
        SCOPES.canViewHorario,
        SCOPES.canViewCalificaciones,
        SCOPES.canViewGrupos,
        SCOPES.canViewsGruposDifusion,
        SCOPES.canViewExamen
    ],
    [ROLES.familiar]: [
        SCOPES.canViewCursos,
        SCOPES.canViewPagos,
        SCOPES.canViewHorario,
        SCOPES.canViewCalificaciones,
        SCOPES.canViewGrupos,
        SCOPES.canViewsGruposDifusion
    ],
    [ROLES.profesor]: [
        SCOPES.canViewCursosProfesor,
        SCOPES.canViewHorario,
        SCOPES.canViewCalificaciones,
        SCOPES.canViewGrupos,
        SCOPES.canViewsGruposDifusion,
        SCOPES.canCreateArchivos,
        SCOPES.canCreateCalificaciones,
        SCOPES.canCreateHorario,
        SCOPES.canViewUserList,
        SCOPES.canTagsList,
        SCOPES.canViewExamen
    ],
    [ROLES.caja]: [
        SCOPES.canCreatePagoManual,
        SCOPES.canViewUserList,
        SCOPES.canTagsList,
    ],
    [ROLES.adminti]: [
        SCOPES.canViewCursos,
        SCOPES.canViewHorario,
        SCOPES.canViewCalificaciones,
        SCOPES.canViewGrupos,
        SCOPES.canViewsGruposDifusion,
        SCOPES.canCreateArchivos,
        SCOPES.canCreateCalificaciones,
        SCOPES.canCreateHorario,
        SCOPES.canUploadPerfilAlumnos,
        SCOPES.canCreateArchivos,
        SCOPES.canDeleteArchivosOtros,
        SCOPES.canDeleteCursos,
        SCOPES.canViewUserList,
        SCOPES.canTagsList,
        SCOPES.canCreateUser,
        SCOPES.canCreateCursos,
        SCOPES.canViewExamen,
        SCOPES.canEditExamen
    ],
    [ROLES.director]: [
        SCOPES.canViewCursos,
        SCOPES.canViewHorario,
        SCOPES.canViewCalificaciones,
        SCOPES.canViewGrupos,
        SCOPES.canViewsGruposDifusion,
        SCOPES.canCreateArchivos,
        SCOPES.canCreateCalificaciones,
        SCOPES.canCreateHorario,
        SCOPES.canCreateInstiElement,
        SCOPES.canDeleteArchivosOtros,
        SCOPES.canDeleteCursos,
        SCOPES.canCreateFactura,
        SCOPES.canDeleteCalificaciones,
        SCOPES.canDeleteHorario,
        SCOPES.canEditInstiElement,
        SCOPES.canUploadPerfilAlumnos,
        SCOPES.canCreateArchivos,
        SCOPES.canViewUserList,
        SCOPES.canTagsList,
        SCOPES.canCreateUser,
        SCOPES.canCreateCursos,
        SCOPES.canViewExamen,
        SCOPES.canEditExamen
    ],

  };


//   export const PERMISSIONS_ = {
//     [ROLES.estudiante]: [SCOPES.canView],
//     [ROLES.estudiante]: [SCOPES.canView],
//     [ROLES.editor]: [SCOPES.canView, SCOPES.canEdit],
//     [ROLES.owner]: [
//       SCOPES.canView,
//       SCOPES.canEdit,
//       SCOPES.canCreate,
//       SCOPES.canDelete
//     ]
//   };
  